// style
import '../css/style.scss';

// libs
import 'swiper/css/bundle';

function importAll(r) {
  r.keys().forEach(r);
}

function importAllComponentsScriptsExceptPreloader(r) {
  const excludedScripts = [
    './Preloader/preloader.js',
    './CookieConsent/consent-manager.js',
    './CookieConsent/cookie-consent.js',
    './CookieConsent/optional-scripts-loader.js',
  ];

  r.keys()
    .filter((key) => !excludedScripts.includes(key))
    .forEach(r);
}

importAll(require.context('./../../assets/resource/fonts/', true, /\.(woff|woff2|eot|ttf|otf)$/));

importAllComponentsScriptsExceptPreloader(require.context('./../../components', true, /\.js$/));
importAll(require.context('./../../components', true, /\.scss$/));

importAll(require.context('./../../blocks', true, /\.js$/));
importAll(require.context('./../../blocks', true, /\.scss$/));

importAll(require.context('./utils', true, /\.js$/));
